export * from './enums';
import { CONFIGURABLE_FIELD_DATA_TYPES } from '../configurable-fields';

export enum COMMISSION_CODE_SPEED_DIAL_BULK_FIELDS {
  INSURER = 'insurer',
  PRODUCT = 'product',
  TRANSACTION_TYPES = 'transaction_types',
  AGENT = 'agent',
  INTERNAL_FIELDS = 'internal_fields',
  RATE = 'rate',
  PERCENTAGE = 'percentage',
}

export const COMMISSION_CODES_SPEED_DIAL = {
  ADD_NEW: 'ADD_NEW',
};

export const commissionCodesExcludedAddFieldTypes: CONFIGURABLE_FIELD_DATA_TYPES[] =
  [
    CONFIGURABLE_FIELD_DATA_TYPES.FORMULA,
    CONFIGURABLE_FIELD_DATA_TYPES.VIEW,
    CONFIGURABLE_FIELD_DATA_TYPES.JSON,
    CONFIGURABLE_FIELD_DATA_TYPES.FILE,
    CONFIGURABLE_FIELD_DATA_TYPES.REFERENCES,
  ];
